import { defineMessages } from 'react-intl';

export default defineMessages({
    customerSince: {
        id: 'ml.gateway.views.policy-detail.Customer Since',
        defaultMessage: 'CUSTOMER SINCE'
    },
    addNewQuote: {
        id: 'ml.gateway.views.policy-detail.AddNewQuote',
        defaultMessage: 'ADD NEW QUOTE'
    },
    makeChanges: {
        id: 'ml.gateway.views.policy-detail.MakeChanges',
        defaultMessage: 'MAKE CHANGES'
    },
    manageBundle: {
        id: 'ml.gateway.views.policy-detail.ManageBundle',
        defaultMessage: 'Create / Manage Bundle'
    },
    navigateTo: {
        id: 'ml.gateway.views.policy-detail.navigateTo',
        defaultMessage: 'Navigate To'
    },
    accountView: {
        id: 'ml.gateway.views.policy-detail.accountView',
        defaultMessage: 'Account View'
    },
    cancelled: {
        id: 'ml.gateway.views.policy-detail.cancelled',
        defaultMessage: 'CANCELLED'
    },
    renewal: {
        id: 'ml.gateway.views.policy-detail.renewal',
        defaultMessage: 'RENEWAL'
    },
    active: {
        id: 'ml.gateway.views.policy-detail.active',
        defaultMessage: 'ACTIVE'
    },
    scheduled: {
        id: 'ml.gateway.views.policy-detail.scheduled',
        defaultMessage: 'SCHEDULED'
    },
    contingencies: {
        id: 'ml.gateway.views.policy-detail.Contingencies',
        defaultMessage: 'Contingencies'
    },
    expired: {
        id: 'ml.gateway.views.policy-detail.expired',
        defaultMessage: 'EXPIRED'
    },
    futureCancellationBanner: {
        id: 'ml.gateway.views.policy-detail.futureCancellationBanner',
        defaultMessage: 'Warning: A cancellation is already scheduled for this policy on {date}.'
    }
})